export default __webpack_public_path__ + "static/media/whychooseicon1.5505e15f.png";